import React from 'react';
import { useTheme, useUI } from '../../context/ThemeContext';
import { F } from '../../styles/theme';

export default function DeltaPill({ value, small = false, plain = false }) {
  const { T } = useTheme();
  const ui = useUI();
  if (value === null || value === undefined || !isFinite(value)) {
    return (
      <span style={{ fontFamily: F.family, color: T.mute, fontSize: small ? 11 : 13, fontWeight: 600 }}>
        –
      </span>
    );
  }
  const pos = value >= 0;
  // v3 Editorial: Pastell statt Brand-Rot. Phase-2-Fallback bleibt funktional.
  const color = pos ? (T.gain || T.green) : (T.loss || T.red);
  const size = small ? 11 : 13;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 2,
        fontFamily: F.family,
        fontSize: size,
        fontWeight: 600,
        color,
        letterSpacing: '-0.02em',
        lineHeight: 1,
        ...(plain
          ? {}
          : {
              padding: small ? '4px 7px' : '5px 9px',
              borderRadius: ui.isMobile ? ui.radius.chip : 8, // Calm: weicher, nicht scharf
              // Calm-Doktrin: kein rot getöntes Verlust-Pill. Gewinn dezent grün,
              // Verlust neutral-warm. Rot bleibt allein der Marke.
              background: pos ? 'rgba(79,156,115,0.10)' : 'rgba(138,124,106,0.10)',
            }),
      }}
    >
      <span style={{ fontSize: small ? 7 : 8, fontWeight: 700, marginRight: 1, opacity: 0.85 }}>
        {pos ? '+' : '−'}
      </span>
      <span>{Math.abs(value).toFixed(2)}</span>
      <span style={{ fontSize: '0.78em', opacity: 0.7, marginLeft: 1 }}>%</span>
    </span>
  );
}
